import type { ReactNode } from 'react';

export const symbol_videogame_asset: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-240q-24 0-42-18t-18-42v-360q0-24 18-42t42-18h680q24 0 42 18t18 42v360q0 24-18 42t-42 18H140Zm0-60h680v-360H140v360Zm150-150v74q0 12.75 8.68 21.37 8.67 8.63 21.5 8.63 12.82 0 21.32-8.63 8.5-8.62 8.5-21.37v-74h74q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5h-74v-74q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v74h-74q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5h74Zm334.5 72.5Q638-391 638-409t-13.5-31.5Q611-454 593-454t-31.5 13.5Q548-427 548-409t13.5 31.5Q575-364 593-364t31.5-13.5Zm90-143Q728-534 728-552t-13.5-31.5Q701-597 683-597t-31.5 13.5Q638-570 638-552t13.5 31.5Q665-507 683-507t31.5-13.5ZM140-300v-360 360Z"
		/>
	</svg>
);
